import { createI18n } from 'vue-i18n'
import messages from './languages'
const acceptedLanguages = ['dk', 'se', 'fi', 'no']

const lang = window.localStorage.getItem('lang')
let locale = 'dk'
if (lang && acceptedLanguages.includes(lang)) {
  locale = lang
}

// Create VueI18n instance with options
export const i18n = createI18n({
  legacy: false, // set 'false' to use Composition API
  globalInjection: true, // make '$t' available in templates
  locale,
  messages,
  warnHtmlMessage: false,
  missingWarn: false
});
